import { render, staticRenderFns } from "./CierrePedido.vue?vue&type=template&id=d80bcae0"
import script from "./CierrePedido.vue?vue&type=script&lang=js"
export * from "./CierrePedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports